import { MutableRefObject, useRef, useState } from 'react';

export const useTimer = (initialState = 0, started?: string | null) => {
    const [timer, setTimer] = useState(initialState);
    const [isActive, setIsActive] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const countRef = useRef() as MutableRefObject<NodeJS.Timeout>;

    const handleStart = () => {
        setIsActive(true);
        setIsPaused(true);
        countRef.current = setInterval(() => {
            setTimer(() => {
                const now = new Date().getTime();
                const date = started ? parseInt(started) * 1000 : 0;
                return Math.floor((now - date) / 1000);
            });
        }, 1000);
    };

    const handlePause = () => {
        clearInterval(countRef.current);
        setIsPaused(false);
    };

    const handleResume = () => {
        setIsPaused(true);
        countRef.current = setInterval(() => {
            setTimer(() => {
                const now = new Date().getTime();
                const date = started ? parseInt(started) * 1000 : 0;
                return Math.floor((now - date) / 1000);
            });
        }, 1000);
    };

    const handleReset = () => {
        clearInterval(countRef.current);
        setIsActive(false);
        setIsPaused(false);
        setTimer(0);
    };

    return { timer, isActive, isPaused, handleStart, handlePause, handleResume, handleReset, setTimer };
};
